import Home from "../main/pages/Home";
import UserManPage from "../auth/pages/UserManPage";
import SiteManPage from "../sites/pages/SiteManPage";

const routes = [
  {
    key: "home",
    path: "/",
    navText: "Home",
    isNav: true,
    component: Home,
  }, 
  {
    key: "user-man",
    path: "/user-man",
    navText: "UserMan",
    isNav: true, // Mostra User Management nel menu
    component: UserManPage,
  },
  {
    key: "site-man",
    path: "/site-man",
    navText: "SiteMan",
    isNav: true, // Impostato a true per mostrare "Sites / SiteMan" nella barra di navigazione
    component: SiteManPage,
  },
];

export default routes;